var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"matchmakerTeamIntro"},[_c('v-h5Mtml',{attrs:{"content":_vm.postData.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }